import { Flex } from '@mantine/core';
import { Practitioner } from '@medplum/fhirtypes';
import { HumanNameDisplay, ResourceAvatar } from '@medplum/react';
import { ReactElement } from 'react';

export interface PractitionerResourceOptionProps {
  resource: Practitioner;
}

/** Renders a practitioner row for Medplum `ResourceInput` `itemComponent`. */
export function PractitionerResourceOption({ resource }: PractitionerResourceOptionProps): ReactElement {
  return (
    <Flex gap="md" align="center">
      <ResourceAvatar value={resource} radius="xl" />
      <HumanNameDisplay value={resource?.name?.[0]} />
    </Flex>
  );
}
